import { gql, useQuery } from '@apollo/client';
import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { GetUserByEmailQueryVariables, Query } from 'generated/graphql';
import {
  MapToUserPermissions,
  MapToUserType,
} from 'v2/core/repository/edge-server/user/userMapper';
import { useGetUser, useGetUserSetter } from 'v2/core/services/user';

export const FETCH_USER_PERMISSIONS = gql`
  query getUserPermissions($email: String!, $slug: String) {
    getUserByEmail(email: $email, slug: $slug) {
      type
      permissions {
        resource
        operation
      }
    }
  }
`;

export const useFetchAndUpdateUserPermissions = () => {
  const { showErrorNotification } = useNotificationContext();

  const user = useGetUser();

  const {
    email,
    tenant: { slug },
  } = user;

  const appSetUser = useGetUserSetter();

  const { data, loading } = useQuery<Query, GetUserByEmailQueryVariables>(
    FETCH_USER_PERMISSIONS,
    {
      variables: {
        email,
        slug,
      },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'cache-and-network',
      skip: !slug,
      onError: () => {
        showErrorNotification({
          contentComponent: 'Failed to fetch user permissions',
          props: {},
        });
      },
      onCompleted: (data) => {
        if (!email || !data.getUserByEmail) {
          return;
        }

        const userType = MapToUserType(data.getUserByEmail.type);

        appSetUser({
          ...user,
          type: userType,
          permissions: MapToUserPermissions(
            data.getUserByEmail.permissions,
            userType,
          ),
        });
      },
    },
  );

  return {
    data,
    loading,
  };
};
